var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.event.monthHeader
      ? _c("div", { staticClass: "event-month-header" }, [
          _c("div", [_vm._v(_vm._s(_vm.event.monthHeader))])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row event-card-wrapper col-12 pb-4 pb-md-3 mx-md-1" },
      [
        _vm.isErrored
          ? _c("div", { staticClass: "alert alert-error" }, [
              _vm._v(_vm._s(_vm.errorMsg))
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "event-date-wrapper col-12 col-md-3 pb-3 pb-md-0" },
          [
            _c("div", { staticClass: "event-month" }, [
              _c("strong", [
                _vm._v(_vm._s(_vm.formattedEventData.calendarMonthText))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "event-day" }, [
              _c("strong", [
                _vm._v(_vm._s(_vm.formattedEventData.calendarDayText))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "event-day-text" }, [
              _c("strong", [
                _vm._v(_vm._s(_vm.formattedEventData.calendarDayString))
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "divisory-line mx-4 my-0 my-md-3 mx-md-0" }),
        _vm._v(" "),
        _c("div", { staticClass: "event-details col-12 col-md-8 pl-4" }, [
          _c(
            "a",
            {
              staticClass: "event-title",
              attrs: { href: "#", target: "_blank" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.navigateToEvent()
                }
              }
            },
            [_c("div", [_c("h4", [_vm._v(_vm._s(_vm.event.title))])])]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "d-inline-block" }, [
            _vm.event.topic
              ? _c("div", { staticClass: "event-topic" }, [
                  _vm._v(_vm._s(_vm.event.topic))
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 col-md-9 pl-md-1 px-0" }, [
            _c("div", { staticClass: "icon-wrapper" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.formattedEventData.eventDescriptionText) +
                    "\n                    "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-inline-block" }, [
              _vm.event.location
                ? _c(
                    "div",
                    { staticClass: "icon-wrapper location-container" },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(_vm.event.location))])
                    ]
                  )
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          !_vm.event.enableRsvp
            ? _c(
                "div",
                {
                  staticClass: "event-add-to-calendar-btn",
                  class: { disabled: _vm.addToCalendarBtnDisabled }
                },
                [
                  _c("div", { staticClass: "icon-wrapper" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _vm.isLoading
                      ? _c("div", { staticClass: "loading-spinner" }, [
                          _c("img", {
                            attrs: {
                              src: _vm.spinnerUrl,
                              alt: "Loading Spinner"
                            }
                          })
                        ])
                      : _c("div", { on: { click: _vm.addEventToCalendar } }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.addToCalendarBtnLabel) +
                              "\n                    "
                          )
                        ])
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.event.enableRsvp
            ? _c(
                "div",
                {
                  staticClass: "event-add-to-rsvp-btn",
                  class: { disabled: _vm.addToRSVPBtnDisabled }
                },
                [
                  _c("div", { staticClass: "icon-wrapper" }, [
                    _vm._m(3),
                    _vm._v(" "),
                    _vm.isRSVPLoading
                      ? _c("div", { staticClass: "loading-spinner" }, [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/spinner.svg"),
                              alt: "Loading Spinner"
                            }
                          })
                        ])
                      : _c("div", { on: { click: _vm.triggerRSVPEvent } }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.addToRSVPBtnLabel) +
                              " \n                    "
                          )
                        ])
                  ])
                ]
              )
            : _vm._e()
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("img", { attrs: { src: require("@/assets/image/icon_time.svg") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("img", { attrs: { src: require("@/assets/image/icon_location.svg") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("img", { attrs: { src: require("@/assets/image/icon_calendar.svg") } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("img", { attrs: { src: require("@/assets/image/icon_calendar.svg") } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2abef0a3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2abef0a3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/eventsByInterests/EventFeedCard.vue
// module id = null
// module chunks = 